module.exports = __webpack_public_path__ + "img/ico19.9be16af7.svg";